/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

 
const radios = document.querySelectorAll('.color .radio__buttons input[type="radio"]');
if (radios.length) {
    radios.forEach((radio) => {
        radio.addEventListener('change', function() {
            console.log("Selected value:", this.value);
          document.querySelectorAll('.product__slide').forEach((slide) => {
              if (slide.getAttribute('data-alt') === this.value) {
                  slide.style.display = "block"; // Show the matching elements
              } else {
                  slide.style.display = "none";  // Hide others
              }
          });

           document.querySelectorAll('.product__thumb').forEach((slide) => {
              if (slide.getAttribute('data-alt') === this.value) {
                  slide.style.display = "block"; // Show the matching elements
              } else {
                  slide.style.display = "none";  // Hide others
              }
          });
        });
    });
}

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
